import RequesterV1 from "@/components/api/v1/requester.js";

export default {

  fetchProviders(agro_exporter_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `agro_exporter/production/query_by_provider/show_process/${agro_exporter_id}/fetch_providers/${agro_exporter_process_id}`
    );
  },

  fetchAgroExporterProcess(agro_exporter_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `agro_exporter/production/query_by_provider/show_process/${agro_exporter_id}/fetch_agro_exporter_process/${agro_exporter_process_id}`
    );
  },

  fetchSummary(agro_exporter_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `agro_exporter/production/query_by_provider/show_process/${agro_exporter_id}/fetch_summary/${agro_exporter_process_id}`
    );
  },

  fetchTotalsWeekly(agro_exporter_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `agro_exporter/production/query_by_provider/show_process/${agro_exporter_id}/fetch_totals_weekly/${agro_exporter_process_id}`
    );
  },

  fetchWeeklySummary(agro_exporter_id, agro_exporter_process_id, current_page, rows_per_page) {
    return RequesterV1.get(
      `agro_exporter/production/query_by_provider/show_process/${agro_exporter_id}/fetch_weekly_summary/${agro_exporter_process_id}/${current_page}/${rows_per_page}`
    );
  },

  fetchTotalWeeklySummary(agro_exporter_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `agro_exporter/production/query_by_provider/show_process/${agro_exporter_id}/fetch_total_weekly_summary/${agro_exporter_process_id}`
    );
  },

  fetchDiscardedMotives(agro_exporter_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `agro_exporter/production/query_by_provider/show_process/${agro_exporter_id}/fetch_discarded_motives/${agro_exporter_process_id}`
    );
  },

  fetchProvidersSummary(agro_exporter_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `agro_exporter/production/query_by_provider/show_process/${agro_exporter_id}/fetch_providers_summary/${agro_exporter_process_id}`
    );
  },

  fetchCropSizeSummary(agro_exporter_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `agro_exporter/production/query_by_provider/show_process/${agro_exporter_id}/fetch_crop_size_summary/${agro_exporter_process_id}`
    );
  },

  fetchCropSizePackagesSummary(agro_exporter_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `agro_exporter/production/query_by_provider/show_process/${agro_exporter_id}/fetch_crop_size_packages_summary/${agro_exporter_process_id}`
    );
  },

  fetchCropSizePackagesByMonths(agro_exporter_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `agro_exporter/production/query_by_provider/show_process/${agro_exporter_id}/fetch_crop_size_packages_by_months/${agro_exporter_process_id}`
    );
  },

  fetchCropSizePackagesByWeeks(agro_exporter_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `agro_exporter/production/query_by_provider/show_process/${agro_exporter_id}/fetch_crop_size_packages_by_weeks/${agro_exporter_process_id}`
    );
  },

  fetchCropSizesByProducer(agro_exporter_id, agro_exporter_process_id, crop_size_id) {
    return RequesterV1.get(
      `agro_exporter/production/query_by_provider/show_process/${agro_exporter_id}/fetch_crop_size_by_provider/${agro_exporter_process_id}/${crop_size_id}`
    );
  },

  fetchCropSizePackagesByProducer(agro_exporter_id, agro_exporter_process_id, crop_size_id) {
    return RequesterV1.get(
      `agro_exporter/production/query_by_provider/show_process/${agro_exporter_id}/fetch_crop_size_packages_by_provider/${agro_exporter_process_id}/${crop_size_id}`
    );
  }
}
